import { DataSource } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { map } from 'rxjs/operators';
import { Observable, of as observableOf, merge } from 'rxjs';

export interface TablaItem {
  number;
  event;
  date;
  seeDownload;
}

const EXAMPLE_DATA: TablaItem[] = [
  { number: '1', event: 'Eventos 20210331', date: '31 -03- 2021',  seeDownload: ''},
  { number: '2', event: 'Eventos 20210401', date: '01 -04- 2021',  seeDownload: ''},
  { number: '3', event: 'Eventos 20210402', date: '20 -04- 2021',  seeDownload: ''}
];

export class TablaDataSource extends DataSource<TablaItem> {
  data: TablaItem[] = EXAMPLE_DATA;
  paginator: MatPaginator;
  sort: MatSort;

  constructor() {
    super();
  }

  connect(): Observable<TablaItem[]> {
    const dataMutations = [
      observableOf(this.data),
      this.sort.sortChange
    ];

    return merge(...dataMutations).pipe(map(() => {
      return this.getPagedData(this.getSortedData([...this.data]));
    }));
  }

  disconnect() { }

  private getPagedData(data: TablaItem[]) {
    const startIndex = 0;
    return data.splice(startIndex, 3);
  }

  private getSortedData(data: TablaItem[]) {
    if (!this.sort.active || this.sort.direction === '') {
      return data;
    }

    return data.sort((a, b) => {
      const isAsc = this.sort.direction === 'asc';
      switch (this.sort.active) {
        case 'number': return compare(a.number, b.number, isAsc);
        case 'event': return compare(+a.event, +b.event, isAsc);
        case 'date': return compare(a.date, b.date, isAsc);
        default: return 0;
      }
    });
  }
}

function compare(a: string | number, b: string | number, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
